// extracted by mini-css-extract-plugin
module.exports = {"news-tag":"eR","newsTag":"eR","dafalut":"eS","qishou":"eT","shangjia":"eU","shehui":"eV","caiwu":"eW","piyao":"eX","suanfa":"eY","keji":"eZ","lingshou":"e0","gongzuo":"e1"};